import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function ProductSection() {
  const features = ['Alimentación USB universal (conéctala a tu laptop, powerbank o cargador)', '3 niveles de temperatura ajustables con un solo botón', 'Correas de velcro ajustables para cualquier tamaño de pierna', 'Material de neopreno transpirable y ergonómico', 'Bolsillo interno para agregar bolsas de hielo (terapia de frío/calor)'];
  return <section className="w-full bg-white py-16 px-4" data-id="element-181">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-182">
        <div data-id="element-183">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-184">
            Rodillera Térmica USB – Diseño Ergonómico
          </h2>
          <p className="text-lg text-slate-600 mb-8" data-id="element-185">
            Diseñada pensando en tu comodidad diaria. Llévala debajo de la ropa
            o úsala mientras descansas en casa. Su diseño inteligente se adapta
            perfectamente a la forma de tu rodilla.
          </p>

          <ul className="space-y-4" data-id="element-186">
            {features.map((feature, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-187">
                <CheckCircleIcon className="w-6 h-6 text-green-500 shrink-0 mt-0.5" data-id="element-188" />
                <span className="text-slate-700 text-lg" data-id="element-189">{feature}</span>
              </li>)}
          </ul>
        </div>

        <div className="relative w-full aspect-square bg-blue-50 rounded-3xl overflow-hidden shadow-lg border border-blue-100" data-id="element-190">
          <img src="https://cdn.magicpatterns.com/uploads/4LAsomKVkvDLLGptT4QMFG/ChatGPT_Image_Mar_14,_2026,_07_53_55_AM.png" alt="Detalle de la rodillera térmica USB con botón de encendido iluminado" className="w-full h-full object-cover" data-id="element-191" />
        </div>
      </div>
    </section>;
}